import styled from 'styled-components';
import chroma from 'chroma-js';

const getAccessibleColor = (textColor: string, backgroundColor: string) => {
  if (!textColor) return 'inherit';

  // WCAG AA minimum contrast for normal text
  const MIN_CONTRAST = 4.5;
  let opacity = 0.7;

  // Increment opacity by 10% until contrast is acceptable or fully opaque
  while (opacity <= 1) {
    const testColor = chroma(textColor).alpha(opacity).css();
    const contrast = chroma.contrast(testColor, backgroundColor);

    if (contrast >= MIN_CONTRAST) {
      return testColor;
    }

    opacity += 0.1;
  }

  return textColor;
};

export const StyledBanner = styled.div<{ $backgroundColor: string }>`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing(1)}px ${({ theme }) => theme.spacing(5)}px;
  position: relative;
`;

export const StyledPreviewBadge = styled.div<{ $textColor?: string; $backgroundColor: string }>`
  position: absolute;
  top: ${({ theme }) => theme.spacing(1)}px;
  left: ${({ theme }) => theme.spacing(2)}px;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)}px;
  color: ${({ $textColor, $backgroundColor }) => getAccessibleColor($textColor, $backgroundColor)};
  border: 1px solid ${({ $textColor, $backgroundColor }) => getAccessibleColor($textColor, $backgroundColor)};
  font-size: ${({ theme }) => theme.typography.generateFontSize(-1)}px;
  padding: ${({ theme }) => theme.spacing(1)}px ${({ theme }) => theme.spacing(2)}px;
  border-radius: ${({ theme }) => theme.radii.md}px;
`;
